<template>
  <vs-card>
    <vs-tabs>
      <vs-tab label="Security" icon-pack="feather" icon="icon-shield">
        <div class="tab-container">
          <div class="w-full flex flex-no-wrap">
            <div class="w-1/2">
              <h5 class="mb-4">Change Password</h5>
              <div class="table-row w-full mb-5">
                <div class="table-cell w-2/5 p-4">Current Password</div>
                <div class="table-cell w-3/5 p-4">
                  <vs-input
                    type="password"
                    placeholder="Current Password"
                    v-model="security.currentPassword"
                    class="w-full mb-4 no-icon-border"
                  />
                </div>
              </div>
              <div class="table-row w-full">
                <div class="table-cell w-2/5 p-4">New Password</div>
                <div class="table-cell w-3/5 p-4">
                  <vs-input
                    type="password"
                    placeholder="New Password"
                    v-model="security.newPassword"
                    class="w-full mb-4 no-icon-border"
                  />
                </div>
              </div>
              <div class="table-row w-full">
                <div class="table-cell w-2/5 p-4">Confirm New Password</div>
                <div class="table-cell w-3/5 p-4">
                  <vs-input
                    type="password"
                    placeholder="Confirm New Password"
                    v-model="security.confirmNewPassword"
                    class="w-full mb-4 no-icon-border"
                  />
                </div>
              </div>
            </div>
            <div class="hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img class="w-1/2 mx-auto" src="@/assets/images/pages/graphic-4.png" alt="login" />
            </div>
          </div>
        </div>
      </vs-tab>
      <vs-tab label="Bank Account" icon-pack="feather" icon="icon-home">
        <div class="tab-container">
          <bank-account />
        </div>
      </vs-tab>
      <vs-tab label="Merchant" icon-pack="feather" icon="icon-shopping-bag">
        <div class="tab-container">
          <sub-merchant />
        </div>
      </vs-tab>
    </vs-tabs>
  </vs-card>
</template>

<script>
import bankAccount from "./bank-account/BankAccount";
import subMerchant from "./sub-merchant/SubMerchant";
export default {
  components: {
    bankAccount,
    subMerchant
  },
  data() {
    return {
      security: {
        currentPassword: "demodemo",
        newPassword: "demo",
        confirmNewPassword: "demo"
      }
    };
  }
};
</script>

<style lang="scss">
.tab-container {
  min-height: 500px;
  margin-top: 25px;
}
</style>
